/* Quick add com seleção de tamanho */
(function () {
  if (window.__qaSizesInit) return;
  window.__qaSizesInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function closeAll(except) {
    document.querySelectorAll('[data-qa-sizes].is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      el.querySelector('[data-qa-panel]').hidden = true;
      el.querySelector('[data-qa-toggle]').setAttribute('aria-expanded', 'false');
    });
  }

  function refreshCart(cartResponse) {
    // Atualiza o contador de itens (seletores comuns em temas Shopify)
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count, .js-cart-count')
        .forEach(function (el) { el.textContent = cart.item_count; });
      // Eventos que vários temas escutam para abrir/atualizar o carrinho lateral
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('qa:added', { bubbles: true, detail: { item: cartResponse, cart: cart } }));
    });
  }

  function addToCart(variantId, btn, status) {
    btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        if (status) status.textContent = 'Adicionado ao carrinho';
        refreshCart(data);
        setTimeout(function () { closeAll(); if (status) status.textContent = ''; }, 1200);
      })
      .catch(function (err) {
        if (status) status.textContent = (err && err.description) || 'Não foi possível adicionar. Tenta outra vez.';
      })
      .finally(function () { btn.classList.remove('is-loading'); });
  }

  // Usa o botão de quick add do próprio tema (escondido), trocando-lhe a variante.
  // Assim o tema trata de adicionar, atualizar e abrir o carrinho lateral.
  function useNative(wrap, variantId) {
    var card = wrap.closest('product-card, .product-card');
    var native = card && card.querySelector('.qa-native');
    if (!native) return false;
    native.setAttribute('data-product-id', variantId);
    native.dataset.productId = variantId;
    native.removeAttribute('disabled');
    native.click();
    setTimeout(closeAll, 300);
    return true;
  }

  // Delegação de eventos: funciona também com filtros e "carregar mais" via AJAX
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-qa-toggle]');
    var size = e.target.closest('.qa-sizes__size');
    var direct = e.target.closest('[data-qa-direct]');
    var wrap = e.target.closest('[data-qa-sizes]');

    if (wrap) { e.preventDefault(); e.stopPropagation(); } // não abrir a página do produto

    if (toggle) {
      var open = !wrap.classList.contains('is-open');
      closeAll(wrap);
      wrap.classList.toggle('is-open', open);
      wrap.querySelector('[data-qa-panel]').hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (size && !size.disabled) {
      if (!useNative(wrap, size.dataset.variantId)) {
        addToCart(size.dataset.variantId, size, wrap.querySelector('[data-qa-status]'));
      }
      return;
    }
    if (direct) {
      if (!useNative(wrap, direct.dataset.variantId)) addToCart(direct.dataset.variantId, direct, null);
      return;
    }
    if (!wrap) closeAll();
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Fecha o painel quando o rato sai do card (como na Stradivarius)
  document.addEventListener('mouseleave', function (e) {
    if (e.target.matches && e.target.matches('[data-qa-sizes].is-open')) closeAll();
  }, true);
})();